const bulletStyles = (bulletColor: string, textColor: string = '') => {
  return {
    'ul, ol': {
      marginLeft: '20px',
    },

    'ul li': {
      paddingLeft: '7px',
    },

    'ol li': {
      paddingLeft: '7px',
    },

    ...(bulletColor && {
      li: {
        color: `${bulletColor} !important`,
      },
    }),
  };
};

export default bulletStyles;
